export default "<footer>\r\n  MyGolfStat {{app_version ? 'v.' + app_version : ''}} © 2025\r\n</footer>\r\n"